/** Colunas do order by da pesquisa das atividades */
export enum AtividadeSearchOrderBy {
    ID = 1,
    Tipo = 2,
    DataEmissao = 3,
    DiaPrazo = 4,
    DiaPrazoESequencia = 5,
    DataConclusao = 6,
    NomeCliente = 7,
    NomeFantasiaCliente = 8,
    Titulo = 9,
    Comentario = 10,
    NomeUsuarioOrigem = 11,
    NomeUsuarioDestino = 12
};
